import { useState, useRef } from 'react';
import { __ } from '@wordpress/i18n';
import { IconSaveSVG, IconSearchSVG } from '../icon';
import { getJkitElements } from './elements/element-list';
import { updateOption } from '../helper/axios';
import { CheckbocControl } from './elements/controls';
import { isPro } from '../helper/license';
import { Loader } from 'react-feather';
import { applyFilters } from '@wordpress/hooks';

const Elements = (props) => {
    const { activeElements, elementCategories, themeMenu } = window['JkitDashboardOption'];
    const { setSnackbar, setShowBanner } = props;
    const active = [];
    const elements = getJkitElements();
    const userPro = applyFilters('jkit.dashboard.is.pro', false);
    if (activeElements.length === 0) {
        elements.map((element) => {
            active[element.name] = element.pro ? userPro : true;
        });
    }
    const [settingValues, setSettingValues] = useState(activeElements.length === 0 ? active : activeElements);

    const controlRef = useRef();
    const [isSave, setIsSave] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [isDiff, setIsDiff] = useState(false);


    const saveOption = async () => {
        setIsSave(true);
        const params = {
            option_name: 'jkit_elements_enable',
            options: settingValues,
            auto_load: true
        }
        await updateOption(params).then(res => {

            if (res) {
                setIsSaved(true);
                setSnackbar(__('Change Saved', 'jeg-elementor-kit'));
                setIsDiff(false);
            } else {
                setSnackbar(__('Saved Failed', 'jeg-elementor-kit'));
            }
            setTimeout(() => {
                setIsSaved(false);
                setIsSave(false);
            }, 1000);
        });
    };


    const enableCategory = (category) => {
        let enable = {};
        elements.forEach((element) => {
            if (element.category === category) {
                enable[element.name] = element.pro ? userPro : true;
            }
        });
        setSettingValues({
            ...settingValues,
            ...enable,
        });
        setIsDiff(true);
    };

    const updateValue = (id, val) => {
        setSettingValues({
            ...settingValues,
            [id]: val,
        });
        setIsDiff(true);
    }


    const disableCategory = (category) => {
        let disable = {};
        elements.forEach((block) => {
            if (block.category === category) {
                disable[block.name] = false;
            }
        });
        setSettingValues({
            ...settingValues,
            ...disable,
        });
        setIsDiff(true);

    };

    const updateAll = (value) => {
        let newValue = {};
        elements.forEach((element) => {
            newValue[element.name] = element.pro ? userPro : value;
        });
        setSettingValues(newValue);
        setIsDiff(true);

    };
    const checkAll = (checkValue) => {
        let checkAll = true;
        elements.forEach((element) => {
            if (settingValues[element.name] !== checkValue && (!element.pro || userPro)) {
                checkAll = false;
            }
        });

        return checkAll;
    };

    const checkAllCategory = (category, checkValue) => {
        let checkAll = true;
        const blockNames = elements
            .filter((block) => {
                return (category?.slug === block?.category) && (!block.pro || userPro);
            }).map(block => {
                return block.name || '';
            });

        const activeBlocks = Object.keys(settingValues).
            filter((key) => blockNames.includes(key)).
            reduce((cur, key) => { return Object.assign(cur, { [key]: settingValues[key] }); }, {});

        Object.keys(activeBlocks).map(key => {
            if (activeBlocks[key] !== checkValue) {
                checkAll = false;
            }
        });

        return checkAll;
    };

    return <div className="f-theme-wrapper">
        <div className="f-theme-content-wrapper">
            <div className="f-theme-content-header">
                <div className="header-control">
                    <h3>{__('Global Control', '--gctd--')}</h3>
                    <div className="button-able">
                        <a className={checkAll(false) ? 'active' : ''} onClick={() => updateAll(false)}>
                            {__('Disable All', '--gctd--')}
                        </a>
                        <a className={checkAll(true) ? 'active' : ''} onClick={() => updateAll(true)}>
                            {__('Enable All', '--gctd--')}
                        </a>
                    </div>
                </div>
                <div className={`f-theme-content-save ${isDiff ? 'save' : ''} ${isSave ? 'load' : ''} ${isSaved ? 'saved' : ''}`} onClick={() => {
                    isDiff && saveOption();
                }}>
                    {isSaved ? <>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 21 20" fill="none">
                                <path d="M16.6673 5L7.50065 14.1667L3.33398 10" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            {__('Saved', 'jeg-elementor-kit')}
                        </span>
                    </> : isSave ? <div className="loading">
                        <Loader size={14} />
                        <span>{__('Loading', 'jeg-elementor-kit')}</span>
                    </div> : <><IconSaveSVG /><span>{__('Save changes', 'jeg-elementor-kit')}</span></>}
                </div>
            </div>
            <div className="f-theme-content-control-wrapper">
                {elementCategories.map((category) => (
                    <>
                        <div className="block-category">
                            <div className="block-category-info">
                                <p>{category.title}</p>
                                <div className="button-able">
                                    <a className={checkAllCategory(category, false) ? 'active' : ''} onClick={() => disableCategory(category.slug)}>
                                        {__('Disable All', '--gctd--')}
                                    </a>
                                    <a className={checkAllCategory(category, true) ? 'active' : ''} onClick={() => enableCategory(category.slug)}>
                                        {__('Enable All', '--gctd--')}
                                    </a>
                                </div>
                            </div>
                            <div className="block-items">
                                {elements
                                    .filter((block) => {
                                        return category?.slug === block?.category;
                                    })
                                    .sort((first, second) => {
                                        let firstPro = first?.pro ? 0 : 100;
                                        let secondPro = second?.pro ? 0 : 100;
                                        let stringCompare = first.title.localeCompare(second.title);
                                        return firstPro - secondPro + stringCompare;
                                    })

                                    .map((block) => {
                                        return (
                                            <div key={block.name} className={`block-item${settingValues[block.name] ? ' active' : ''} ${block.pro ? ' item-pro' : ''}`}>
                                                <div className="block-info">
                                                    <i className={`element-icon ${block.name}`}></i>
                                                    <p className="block-title">{block?.title}</p>
                                                </div>
                                                {block.pro ? applyFilters('jkit.dashboard.elements.checkbox', <ProButton setShowBanner={setShowBanner} />, {
                                                    name: block.name,
                                                    value: settingValues[block.name],
                                                    updateValue: updateValue,
                                                    controlRef: controlRef
                                                }) : <div className="block-control" ref={controlRef}>
                                                    <CheckbocControl value={settingValues[block.name]} onClick={(value) => { updateValue(block.name, value, block?.pro); }} />
                                                </div>}

                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </>
                ))}
            </div>
        </div >
    </div>;
};

const ProButton = ({ setShowBanner }) => {
    return <span className='pro-button' onClick={() => setShowBanner(true)}>
        <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.82025 2.14721C7.74296 2.08158 7.64722 2.0398 7.54527 2.02722C7.44333 2.01464 7.33983 2.03183 7.24803 2.07659L5.73523 2.80721L4.445 0.7294C4.39878 0.655055 4.33351 0.593549 4.25551 0.550852C4.17752 0.508155 4.08946 0.485718 3.99987 0.485718C3.91029 0.485718 3.82223 0.508155 3.74424 0.550852C3.66624 0.593549 3.60097 0.655055 3.55474 0.7294L2.26451 2.80721L0.751397 2.0769C0.659693 2.03252 0.556482 2.01542 0.454767 2.02777C0.353052 2.04011 0.257383 2.08134 0.179813 2.14627C0.102243 2.2112 0.0462413 2.29691 0.0188636 2.39262C-0.00851405 2.48833 -0.00604316 2.58974 0.025965 2.68409L1.21943 6.22628C1.2374 6.27964 1.26751 6.32842 1.30754 6.36901C1.34757 6.40959 1.39649 6.44095 1.4507 6.46078C1.50491 6.4806 1.56302 6.48839 1.62074 6.48355C1.67847 6.47872 1.73434 6.46139 1.78423 6.43284C1.79197 6.42847 2.59256 5.98565 3.99923 5.98565C5.4059 5.98565 6.20649 6.42909 6.21262 6.43253C6.26251 6.46145 6.31849 6.4791 6.37639 6.48419C6.43429 6.48927 6.49263 6.48165 6.54708 6.4619C6.60153 6.44214 6.65068 6.41076 6.69089 6.37008C6.7311 6.3294 6.76134 6.28046 6.77935 6.2269L7.97282 2.68659C8.00576 2.59219 8.00883 2.49041 7.98165 2.3943C7.95446 2.2982 7.89826 2.21215 7.82025 2.14721ZM6.17746 5.59565C5.74685 5.43565 5.00561 5.23565 3.99923 5.23565C2.99285 5.23565 2.25161 5.43628 1.821 5.59628L0.950092 3.01159L2.12839 3.5794C2.2455 3.63539 2.38 3.64684 2.50539 3.6115C2.63078 3.57615 2.73795 3.49658 2.80577 3.38846L3.99923 1.4669L5.19269 3.38878C5.26051 3.49689 5.3677 3.57645 5.49311 3.61174C5.61851 3.64703 5.75301 3.63549 5.87006 3.5794L7.04804 3.01065L6.17746 5.59565Z" fill="white" />
        </svg>
        <span>PRO</span>
    </span>
}

export default Elements;